export default __webpack_public_path__ + "static/media/paint-08 (2).c6d27854.jpg";